import createMatcher from 'feather-route-matcher';

const router = createMatcher({
  '/': () => import('~/pages/page/index'),
  '/fields/new': () => import('~/pages/fields/new'),
  '/fields': () => import('~/pages/fields/new'), // error of field creation
  '/fields/:id/edit': () => import('~/pages/fields/edit'),
  '/fields/:id/inspections': () => import('~/pages/fields/inspections/index'),
  '/devices/:id': () => import('~/pages/devices/show'),
  '/devices/:id/edit': () => import('~/pages/devices/edit'),
  '/profile': () => import('~/pages/profile/edit'),
  '/users/:id': () => import('~/pages/users/show'),
  '/users/:id/edit': () => import('~/pages/users/edit'),
  '/weather': () => import('~/pages/weather/index'),
  '/disease-map': () => import('~/pages/page/disease_map'),
});

export default () => {
  const match = router(window.location.pathname);
  if (match && match.value) {
    match.value().then(({ default: load }) => load());
  }
};
